import React, {useMemo} from 'react';
import styled, { css } from 'styled-components';

import { getDestinationLabelAndIcon } from 'shared/utils/destination';

import { DestinationNameCellProps } from './types';
import { SourceIcon } from 'component-library-and-tools';
import { DestinationType } from 'shared/types/destination';

const StyledContainer = styled.div`
  flex: 1;

  display: flex;
  align-items: center;
`;

// This includes a temporary edge case handling of the default destination Icon style
const StyledDestinationIcon = styled(SourceIcon)<{destinationType: string}>`
  && {
    font-size: 1.75rem;
    margin-right: 0.25rem;

    ${({destinationType}) => (destinationType === DestinationType.ENCLAVE) && css`
      border-radius: 4rem;
      overflow: hidden;

    `};
  }
`;

const StyledDestinationName = styled.span``;

const DestinationNameCell = ({
  value: destinationType,
}: DestinationNameCellProps) => {

  const uiData = useMemo(() => {
    return getDestinationLabelAndIcon(destinationType);
  }, [destinationType]);

  return (
    <StyledContainer>
      <StyledDestinationIcon name={uiData.label} destinationType={destinationType} icon={uiData.icon} />
      <StyledDestinationName>{uiData.label}</StyledDestinationName>
    </StyledContainer>
  );
}
export default DestinationNameCell;